/* oxlint-disable react/forbid-elements */
import { createIcon, type ISVGIconProps, type ISVGProps } from '@cian/ui-kit-design-tokens/internal';
import * as React from 'react';

const IconComponent = React.forwardRef((props: ISVGProps, ref: React.Ref<SVGSVGElement>) => {
  return (
    <svg {...props} ref={ref} width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M3 0a1 1 0 00-1 1v21H0v2h24v-2h-2v-9a1 1 0 00-1-1h-5V1a1 1 0 00-1-1H3zm17 22v-8h-4v8h4zm-6 0V2H4v20h2v-6h6v6h2zm-4 0v-4H8v4h2zM8 4v4H6V4h2zm0 10v-4H6v4h2zm4-4v4h-2v-4h2zm0-6v4h-2V4h2z"
        clipRule="evenodd"
      />
    </svg>
  );
});

IconComponent.displayName = 'IconSaleRent24';

export const IconSaleRent24: React.FC<ISVGIconProps> = createIcon(IconComponent);
